import axiosStatic from 'axios';

/**
 * @description Создать новый экземпляр клиента Axios.
 * @param {string}             baseURL            Базовый ресурс запросов.
 * @param {function(): string} resolveToken       Получить токен аутентификации.
 * @param {string}             defaultContentType Тип содержимого запроса по умолчанию.
 * @returns {import('axios').AxiosInstance}
 */
export function createAxios(
  baseURL,
  resolveToken,
  defaultContentType = 'application/json',
) {
  const headers = { 'Content-Type': defaultContentType };
  const instance = axiosStatic.create({ baseURL, headers });
  instance.interceptors.request.use((config) => {
    const token = resolveToken();
    if (token !== '') {
      Object.assign(config.headers, { Authorization: `Token ${token}` });
    }
    if ((config.headers['Content-Type'] || '') === '') {
      Object.assign(config.headers, { 'Content-Type': defaultContentType });
    }
    return config;
  });
  return instance;
}